import { useMutation } from '@apollo/client';
import { INITIATE_PHONE_VERIFICATION } from '../bookingTypeDefs';

export const useMutationInitiatePhoneVerification = (options?: any): any => {
  return useMutation(INITIATE_PHONE_VERIFICATION, options);
};
